import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { CONFIG } from "@/config";

// Video-shaped cover shown before registration. Only the thumbnail is loaded, never the player.
export const VideoPoster = ({ onPlay }) => {
  const [thumb, setThumb] = useState(null);
  const [aspect, setAspect] = useState("16 / 9");

  useEffect(() => {
    fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(CONFIG.VIMEO_URL)}&width=1280`)
      .then((r) => r.json())
      .then((d) => {
        if (d.thumbnail_url) setThumb(d.thumbnail_url);
        if (d.width && d.height) setAspect(`${d.width} / ${d.height}`);
      })
      .catch(() => {});
  }, []);

  return (
    <motion.button
      type="button"
      onClick={onPlay}
      className="player-frame group block w-full text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B6F23C]"
      initial={{ opacity: 0, y: 40, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.45 }}
      aria-label={CONFIG.gate.playLabel}
      data-testid="video-poster"
    >
      <div className="player-inner relative overflow-hidden bg-[#141612]" style={{ aspectRatio: aspect }}>
        {thumb && (
          <img
            src={thumb}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-[1.03]"
            data-testid="video-poster-thumbnail"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0A] via-[#0B0C0A]/30 to-transparent" />

        <div className="absolute inset-0 flex items-center justify-center">
          <span className="relative flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full bg-[#B6F23C] text-[#0B0C0A] shadow-[0_0_50px_rgba(182,242,60,0.45)] transition-transform duration-300 group-hover:scale-110">
            <span className="absolute inset-0 rounded-full bg-[#B6F23C]/40 animate-ping [animation-duration:2.2s]" />
            <Play className="relative h-8 w-8 sm:h-10 sm:w-10 fill-current ml-1" />
          </span>
        </div>

        <div className="absolute inset-x-0 bottom-0 p-4 sm:p-6">
          <span className="text-sm sm:text-base font-medium text-[#F4F5F2]">{CONFIG.gate.playLabel}</span>
        </div>
      </div>
    </motion.button>
  );
};
